import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-rlhf',
  templateUrl: './rlhf.component.html',
  styleUrls: ['./rlhf.component.scss']
})
export class RLHFComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('以人類反饋強化學習（RLHF）｜為企業打造精準且擬人化的 AI');
    this.metaTagService.updateTag({ name: 'description', content: "了解 RLHF 如何透過人類反饋微調 AI 模型，提升準確度與自然回應善用人類反饋，打造客製化、精確且具適應力的企業專屬 AI" });
    this.metaTagService.updateTag({ property: 'og:title', content: "以人類反饋強化學習（RLHF）｜為企業打造精準且擬人化的 AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "了解 RLHF 如何透過人類反饋微調 AI 模型，提升準確度與自然回應善用人類反饋，打造客製化、精確且具適應力的企業專屬 AI" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/rlhf' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/rlhf' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '以人類反饋強化學習（RLHF）｜為企業打造精準且擬人化的 AI' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "了解 RLHF 如何透過人類反饋微調 AI 模型，提升準確度與自然回應善用人類反饋，打造客製化、精確且具適應力的企業專屬 AI" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/custom-ai-models/rlhf' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/custom-ai-models/rlhf' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    // console.log("Country is", this.country);
  }

}
